<template>
  <v-card>
    <v-card-title class="white py-5 px-8 grey--text text--darken-2" style="border-bottom: 1px solid #eee !important">
      <v-icon class="ml-3">mdi-account-group</v-icon>
      عدد الزوار اخر 30 يوم
      <v-spacer />
      <v-btn
        icon
        large
        text
        class="mx-2"
        title="تصدير لإكسيل"
        color="green darken-2"
        @click="SET_FILTERS({ type: 'visitors-views' }); SHOW_EXPORT_DIALOG()"
      >
        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="py-7">
      <v-container>
        <v-progress-linear
          v-if="loading"
          color="primary"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
        <visitors-chart
          v-else
          :options="options"
          :chart-data="chartData"
        ></visitors-chart>
      </v-container>
    </v-card-text>
  </v-card>
</template>


<script>
import { mapState, mapMutations } from 'vuex';
import VisitorsChart from './VisitorsChart.js'

export default {
  name: 'chart-statistics',
  props: ['statistics', 'loading'],
  components: { VisitorsChart },
  
  data: function () {
    return {
      chartData: null,
      options: {
        responsive: true,
        legend: { display: false },
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: { display: true, labelString: 'عدد الزوار' }
          }],
          xAxes: [{
            scaleLabel: { display: true, labelString: 'الأيام' }
          }]
        }
      }
    }
  },

  
  watch: {
    statistics: {
      handler(days) {
        if (!days) return;

        const labels = [];
        const values = [];

        for (const day of days) {
          labels.push(day.date);
          values.push(day.visitors);
        }

        this.chartData = {
          labels: labels,
          datasets: [
            {
              fill: true,
              data: values,
              label: 'عدد الزوار',
              backgroundColor: '#0097a7',
              pointBorderColor: '#0097a7',
              pointBackgroundColor: '#0097a7',
            }
          ]
        };
      },
      immediate: true
    }
  },


  methods: {
    ...mapMutations(
      'statistics', ['SHOW_EXPORT_DIALOG', 'SET_FILTERS']
    )
  }
}
</script>
